export const AUTH_HEADERS = {
    Accept: "application/json",
    Authorization: "Bearer "
};
